// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeReasonAuthShared = {
  activityMemberInactive: "{resource}活动成员未启用",
  activityRoleRequired: "当前账号缺少{resource}活动角色",
  adminAccessRequired: "当前账号没有{resource}管理员权限",
  appSessionRequired: "当前请求缺少{resource}应用会话",
  applicationAccessDenied: "当前账号无权访问{resource}应用",
  applicationContextInvalid: "{resource}应用上下文不合法",
  authorizationPromptInvalid: "{resource}认证 prompt 不在允许集合内",
  avatarMustBeImage: "{resource}头像必须是图片",
  candidateAccountExpired: "{resource}候选账号已过期",
  invalidAuthMode: "{resource}认证模式无效",
  invalidReturnPath: "{resource}返回路径必须是合法的应用内相对路径",
  invalidSsoBffResponse: "{resource}SSO BFF 响应不符合合同",
  memberAccessRequired: "当前账号缺少{resource}成员访问资格",
  memberInactive: "{resource}成员未启用",
  missingRefreshToken: "{resource}缺少刷新令牌",
  oidcRequestFailed: "{resource}OIDC/BFF 请求失败",
  oidcTransactionMissing: "{resource}OIDC 回调缺少认证事务",
  redirectUriNotConfigured: "{resource}缺少 OIDC callback redirect URI 配置",
  sessionInvalidated: "{resource}会话已失效，请重新登录",
  siteMaintenance: "{resource}站点维护中",
  ssoBffNotConfigured: "{resource}SSO BFF client 配置不完整",
  ssoBootstrapFailed: "{resource}SSO 初始化失败",
  teacherAccessRequired: "当前账号没有{resource}教师权限",
  userInactiveOrNotFound: "{resource}用户不存在或未启用",
} as const;
